export default "{\n    \"header\": \"Point of Contact\",\n    \"fullName\": \"Full Name\",\n    \"phoneNumber\": \"Phone Number\"\n}\n"